import PatientRegisterComposer from '../../../composers/PatientRegisterComposer';

export default function PatientRegisterPage(): JSX.Element {
  return <PatientRegisterComposer />;
}
